import { render, staticRenderFns } from "./panel_administrativo.vue?vue&type=template&id=60004e00&scoped=true"
import script from "./panel_administrativo.vue?vue&type=script&lang=js"
export * from "./panel_administrativo.vue?vue&type=script&lang=js"
import style0 from "./panel_administrativo.vue?vue&type=style&index=0&id=60004e00&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60004e00",
  null
  
)

export default component.exports